<template>
  <div class="mb-7">
    <FormHeading :h="3">{{ $tt('passport_personal_details') }}</FormHeading>
    <AppAlert type="warning" class="mb-3">
      <span v-html="$tt('exactly_as_in_passport')" />
    </AppAlert>
    <AppAlert
      v-if="yearValidAndTwoEmptyPages || halfYearValid"
      icon="mdi:alert-circle-outline"
    >
      <template v-if="yearValidAndTwoEmptyPages">
        {{ $tt('passport_year_valid_two_empty_pages') }}
      </template>
      <template v-else>
        <span v-if="biometric">
          {{ $tt('passport_biometric_only') }}
          <br>
        </span>
        <span v-if="halfYearValid">
          {{ $tt('passport_half_year_valid') }}
        </span>
      </template>
    </AppAlert>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  yearValidAndTwoEmptyPages?: boolean;
  halfYearValid?: boolean;
  biometric?: boolean;
}>();
</script>

<style scoped>
  span {
    font-weight: 500;
  }
  :deep(strong) {
    text-decoration: underline;
  }
</style>